import { isMessageIdAtMost } from "./message-id.js";

// Статус исходящего сообщения: «⏱» отправляется, «✓» отправлено, «✓✓»
// прочитано. Раньше жил внутри chat-view.tsx; вынесен, чтобы предпросмотр
// чата в списке диалогов (Alt+клик / «Предпросмотр») рисовал те же галочки,
// что и лента, — без импорта dialog-list ← chat-view по кругу.
export type MessageStatusLabel = "⏱" | "✓" | "✓✓";

export const messageStatusLabel = (
  outgoing: boolean,
  messageId: string,
  occurredAt: string,
  isPending: boolean | undefined,
  lastReadOutboxMessageId?: string,
  lastReadOutboxAt?: string
): MessageStatusLabel | null => {
  if (!outgoing) {
    return null;
  }

  if (isPending) {
    return "⏱";
  }

  if (isMessageIdAtMost(messageId, lastReadOutboxMessageId)) {
    return "✓✓";
  }

  if (lastReadOutboxAt && occurredAt <= lastReadOutboxAt) {
    return "✓✓";
  }

  return "✓";
};
